import React from 'react';
import Carouseluser from '../../components/Carouseluser';

const Dashboard = () => {



  return (
        <Carouseluser />

  );
};

export default Dashboard;
